import classNames from 'classnames'
import type { FC } from 'react'
import React, { useEffect } from 'react'

import { useTableContext } from './table-context'
import type { TableRowProps } from './types'
import useHover from '../../hooks/use-hover'
import { BoxPrivate } from '../_primitives/box/box'

export const TableRow: FC<TableRowProps> = ({
  variant = 'row',
  className,
  children,
  onHover,
  ...props
}) => {
  const { variant: tableVariant } = useTableContext()
  const [isHovering, hoverRef] = useHover<HTMLDivElement>()
  // eslint-disable-next-line no-console
  // console.log('rendering tables.row')
  useEffect(() => {
    if (onHover) {
      onHover(isHovering, hoverRef)
    }
  }, [onHover, isHovering, hoverRef])
  return (
    <BoxPrivate
      __themeKey="tables"
      variant={tableVariant ? `${tableVariant}.row` : variant}
      as="tr"
      className={classNames('csg-tui-tr', className)}
      ref={hoverRef}
      {...props}
    >
      {children}
    </BoxPrivate>
  )
}

export default TableRow
